import React, { useState,useRef  } from "react";
import { useEffect } from "react";
import { BsChevronCompactLeft, BsChevronCompactRight } from "react-icons/bs";
import { RxDotFilled } from "react-icons/rx";
import { Link } from "react-router-dom";
import "./css/style.css";
import { FiShare2 } from 'react-icons/fi';
import ClipboardJS from 'clipboard';
import { TAX_PERCENT, calcTaxAmount } from "../../utils/tax";
import { amenityIconFilterClass } from "../../utils/amenityIcon";
const HotelCard = ({
  villadata,
  amenitiesAll,
  handleCardClick,
  tempStartDate,
  tempEndDate,
}) => {
  //console.log(tempStartDate, tempEndDate, "dates");
  const filteredArray = amenitiesAll
    .filter((item) =>
      villadata.amenities.some((obj) => obj.amenities_id === item.id)
    )
    .map(({ id, name, icon }) => ({ id, name, icon: icon.file }));

  const slidesdummy = [
    {
      source:
        "https://images.unsplash.com/photo-1610513320995-1ad4bbf25e55?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
    },
  ];

  const [slides, setSlide] = useState(slidesdummy);
  const [showModal, setShowModal] = useState(false)

  const {
    property_name,
    building,
    review_count,
    rating,
    price_guest_pay,
    is_recommended,
    area,
  } = villadata;
  const [currentIndex, setCurrentIndex] = useState(0);

  const prevSlide = () => {
    const isFirstSlide = currentIndex === 0;
    const newIndex = isFirstSlide ? slides.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
  };

  const nextSlide = () => {
    const isLastSlide = currentIndex === slides.length - 1;
    const newIndex = isLastSlide ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
  };

  const goToSlide = (slideIndex) => {
    setCurrentIndex(slideIndex);
  };

  const handleimages = () => {
    if (villadata.media_order.length > 0) {
      villadata.media.sort((a, b) => {
        const indexA = villadata.media_order.indexOf(a.media.id);
        const indexB = villadata.media_order.indexOf(b.media.id);
        return indexA - indexB;
      });
    }

    if (villadata.media.length > 0) {
      const newArray = villadata.media.map((item) => {
        return {
          source: item.media.file,
        };
      });

      setSlide(newArray);
    }
    else{
      setSlide(slidesdummy)
    }
  };
  const linkRef = useRef(null)
  useEffect(() => {
    handleimages();
  }, [villadata]);
  const handleShareClick = () => {
    // Copy the sharable link and message to the clipboard
    const link = `${window.location.origin}/villa/${villadata.property_ptr_id}/${villadata.property_name.replace(/\s+/g, '-')}`;

    const clipboard = new ClipboardJS(linkRef.current, {
      text: () => link,
    });

    clipboard.on('success', () => {
      // Show the modal popup when the link is copied
      setShowModal(true);
      clipboard.destroy();
    });

    clipboard.on('error', (err) => {
      console.error('Could not copy text: ', err);
      clipboard.destroy();
    });
  };
  return (
    // <section className="main-content font-hk">

    // </section>
    <>
      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
          <div className="absolute inset-0 bg-black opacity-50"></div>
          <div className="bg-white p-6 rounded font-hk shadow-lg relative z-10 flex flex-col items-center">
            <p className="text-lg mb-4">Sharable link copied!</p>
            <button
              className="px-6 py-2 bg-black text-white rounded-full mt-auto transition-all hover:scale-[1.05]"
              onClick={() => setShowModal(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}

      <div className="container font-hk group w-full sm:w-9/12 md:w-9/12 lg:w-[70vw]  lg:ml-6">
        {is_recommended && (
          <div className="absolute z-20 -mt-1 sm:[15vw] md:ml-[15vw] lg:ml-[49vw] group-hover:-translate-y-1 group-hover:scale-[1.05] transition-all">
            <svg
              width="157"
              height="55"
              viewBox="0 0 157 55"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g filter="url(#filter0_d_128_96)">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M4 5H11V47L78.5 31.3333L146 47V5H153L146 0H11L4 5Z"
                  fill="black"
                />
              </g>
              <path
                d="M33.0241 22L30.3921 17.744C31.5541 17.352 32.1981 16.456 32.1981 15.056C32.1981 13.306 31.2041 12.242 28.8801 12.242H25.6881V22H27.4241V17.954H28.0681H28.6561L30.9941 22H33.0241ZM27.4241 16.344V13.852H28.6981C29.8321 13.852 30.4481 14.132 30.4481 15.084C30.4481 16.036 29.8321 16.344 28.6981 16.344H27.4241ZM34.397 22H40.893V20.39H36.147V17.786H40.557V16.176H36.147V13.852H40.893V12.242H34.397V22ZM47.002 22.21C49.088 22.21 50.656 21.188 51.356 19.298L49.718 18.682C49.298 19.914 48.346 20.544 47.002 20.544C45.126 20.544 44.02 19.298 44.02 17.1C44.02 14.916 45.112 13.684 47.002 13.684C48.332 13.684 49.284 14.286 49.718 15.504L51.328 14.874C50.614 13.012 49.06 12.018 47.002 12.018C44.118 12.018 42.27 13.992 42.27 17.114C42.27 20.236 44.118 22.21 47.002 22.21ZM56.7754 22.21C59.5474 22.21 61.4374 20.18 61.4374 17.128C61.4374 14.062 59.5614 12.032 56.7754 12.032C54.0034 12.032 52.1134 14.062 52.1134 17.128C52.1134 20.18 54.0034 22.21 56.7754 22.21ZM56.7754 20.544C54.9974 20.544 53.8634 19.242 53.8634 17.128C53.8634 15 54.9974 13.698 56.7754 13.698C58.5534 13.698 59.6874 15.014 59.6874 17.128C59.6874 19.228 58.5534 20.544 56.7754 20.544ZM70.7494 12.242L68.2294 19.116L65.7234 12.242H63.2174V22H64.9674V14.706L67.3894 21.146H69.0834L71.5054 14.706V22H73.2554V12.242H70.7494ZM83.2454 12.242L80.7254 19.116L78.2194 12.242H75.7134V22H77.4634V14.706L79.8854 21.146H81.5794L84.0014 14.706V22H85.7514V12.242H83.2454ZM88.2095 22H94.7055V20.39H89.9595V17.786H94.3695V16.176H89.9595V13.852H94.7055V12.242H88.2095V22ZM102.662 12.242V18.962L98.5605 12.242H96.7545V22H98.5045V15.252L102.592 22H104.412V12.242H102.662ZM106.872 22H109.686C112.99 22 114.782 20.306 114.782 17.198C114.782 14.034 112.934 12.242 109.7 12.242H106.872V22ZM108.622 20.39V13.852H109.672C111.982 13.852 113.018 14.874 113.018 17.128C113.018 19.424 111.982 20.39 109.518 20.39H108.622ZM116.551 22H123.047V20.39H118.301V17.786H122.711V16.176H118.301V13.852H123.047V12.242H116.551V22ZM125.096 22H127.91C131.214 22 133.006 20.306 133.006 17.198C133.006 14.034 131.158 12.242 127.924 12.242H125.096V22ZM126.846 20.39V13.852H127.896C130.206 13.852 131.242 14.874 131.242 17.128C131.242 19.424 130.206 20.39 127.742 20.39H126.846Z"
                fill="#FDFE03"
              />
              <defs>
                <filter
                  id="filter0_d_128_96"
                  x="0"
                  y="0"
                  width="157"
                  height="55"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_128_96"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_128_96"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </div>
        )}
        <div className=" flex flex-col md:flex-row justify-center shadow-lg ">
          <div className="w-full sm:w-9/12 md:w-9/12 lg:w-[70vw] p-3 bg-[#f5f1f1]  rounded-sm shadow">
            <div className="hotel-card overflow-hidden lg:flex">
              <div className="max-w-[1400px] h-[300px] lg:h-auto w-full   lg:w-4/12   relative group">
                <div
                  style={{
                    backgroundImage: `url(${slides[currentIndex].source})`,
                  }}
                  className="w-auto h-full rounded-sm bg-center bg-cover duration-800"
                ></div>
                {/* Left Arrow */}
                <div className="hidden group-hover:block absolute top-[50%] -translate-x-0 translate-y-[-50%] left-5 text-2xl rounded-full p-2 bg-black/20 text-white cursor-pointer">
                  <BsChevronCompactLeft onClick={prevSlide} size={40} />
                </div>
                {/* Right Arrow */}
                <div className="hidden group-hover:block absolute top-[50%] -translate-x-0 translate-y-[-50%] right-5 text-2xl rounded-full p-2 bg-black/20 text-white cursor-pointer">
                  <BsChevronCompactRight onClick={nextSlide} size={40} />
                </div>
                {/* <div className="flex top-4 justify-center py-2"> */}
                {/* {slides.map((slide, slideIndex) => (
                  <div
                    key={slideIndex}
                    onClick={() => goToSlide(slideIndex)}
                    className="text-2xl cursor-pointer"
                  >
                    <RxDotFilled />
                  </div>
                ))} */}
                {/* </div> */}
              </div>

              <div className="hotel-card_info p-4 lg:flex lg:flex-col lg:justify-between">
                <div className="flex  mb-2">
                  <div className="flex flex-col">
                    <div className="flex flex-col lg:flex-row">
                      <div
                        className="mb-2 mr-2 font-bold text-[24px] text-black hover:cursor-pointer hover:underline"
                        onClick={() => {
                          handleCardClick(
                            villadata.property_ptr_id,
                            property_name
                          );
                        }}
                      >
                        {property_name}
                      </div>
                      
                      <div className="my-auto flex items-center">
                        <i className="fas fa-star text-[#FFC107]" />
                        <i className="fas fa-star text-[#FFC107]" />
                        <i className="fas fa-star text-[#FFC107]" />
                        <i className="fas fa-star text-[#FFC107]" />
                        <i className="fas fa-star text-[#FFC107]" />
                        <button className="ml-5 transition-all hover:scale-[1.4] focus:outline-none" ref={linkRef}  onClick={handleShareClick}>
                      <FiShare2 size={25} />
                      </button>
                      </div>
                      
                    </div>
                    <div className=" mb-1 text-black text-[17px]">
                      <i className="fas fa-map-marker-alt text-[#ed4540] opacity-100 text-[22px]" />{" "}
                      {building}
                    </div>
                    {/* <div className=" mb-2 text-black text-[15px] ">
                  <i class="fa-solid fa-house text-[#ed4540] text-[18px]"></i> {area}
                  </div> */}
                  </div>

                  <a href="#!" className="text-gray-900 ml-auto -mt-3 -mr-2">
                    <div className="flex flex-row space-x-2 ">
                      <div className="">
                        <h1 className=" text-[#F31F1F] font-medium text-[17px] ">
                          Marvellous
                        </h1>
                        <h2 className="text-black text-[15px] font-semibold">
                          {review_count} reviews
                        </h2>
                        {/* <i className="far fa-heart text-red-500 fa-lg" /> */}
                      </div>
                      <div className=" my-auto">
                        <span className="bg-black text-white p-2 pb-2 text-center rounded-lg text-[17px] ">
                          {villadata.a2z_score === null
                            ? "N/A"
                            : villadata.a2z_score}
                          {/* {villadata.a2z_score} */}
                        </span>
                      </div>
                    </div>
                  </a>
                </div>
                <div className="flex justify-between  ">
                  <div className="mr-4 flex flex-col justify-between ">
                    <div className="flex flex-row mb-4 ">
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_133_311)">
                          <path
                            d="M15.9961 14.8652L14.7391 7.93984C14.7266 7.87071 14.6837 7.81084 14.6223 7.77668L11.4585 6.01699C11.4174 5.99411 11.3714 5.98502 11.3262 5.98852L11.9018 13.4138L11.8825 13.4224L15.6689 15.1211C15.6997 15.1349 15.7324 15.1417 15.765 15.1417C15.8166 15.1417 15.8677 15.1247 15.9098 15.0918C15.9785 15.0382 16.0117 14.9509 15.9961 14.8652Z"
                            fill="#44C868"
                          />
                          <path
                            d="M7.99997 7.69923L4.76418 6.01389C4.7254 5.99367 4.6824 5.98542 4.64005 5.98826C4.65127 5.98757 4.66255 5.98764 4.67374 5.98851L4.09814 13.4138L7.90381 15.1211C7.93453 15.1348 7.96731 15.1417 7.99997 15.1417V7.69923Z"
                            fill="#44C868"
                          />
                          <path
                            d="M4.67376 5.98855C4.62854 5.98505 4.58251 5.99415 4.54144 6.01699L1.37759 7.77668C1.31615 7.81084 1.27328 7.87068 1.26075 7.93984L0.00377743 14.8652C-0.0117851 14.9509 0.021465 15.0381 0.0901213 15.0918C0.132215 15.1247 0.183309 15.1417 0.234872 15.1417C0.267465 15.1417 0.300247 15.1349 0.331028 15.1211L4.09679 13.4317L4.67376 5.98855Z"
                            fill="#4CE166"
                          />
                          <path
                            d="M11.3262 5.98839C11.2951 5.9908 11.2643 5.99908 11.2358 6.01395L8 7.69927V15.1417C8 15.1417 8 15.1417 8.00003 15.1417C8.03269 15.1417 8.0655 15.1349 8.09619 15.1211L11.9019 13.4138L11.3262 5.98839Z"
                            fill="#4CE166"
                          />
                          <path
                            d="M0.879856 10.0386L0.624512 11.4454L4.40558 9.44833L4.49336 8.31586L4.50792 8.12805L0.879856 10.0386Z"
                            fill="#FFDB56"
                          />
                          <path
                            d="M4.43957 9.0092L4.40554 9.44833L0.624466 11.4454L0.00377743 14.8652C-0.0117851 14.9509 0.021465 15.0381 0.0901213 15.0918C0.132215 15.1247 0.183309 15.1417 0.234872 15.1417C0.267465 15.1417 0.300247 15.1349 0.331028 15.1211L4.09679 13.4317L4.43957 9.0092Z"
                            fill="#A8EEFC"
                          />
                          <path
                            d="M8.00118 8.62752L4.50811 8.12805L4.40576 9.44833L8.00024 14.9071V12.9221L5.85533 9.54467L8.00118 9.80133V8.62752Z"
                            fill="#FFBB24"
                          />
                          <path
                            d="M14.3737 7.63817L12.8539 6.79282L11.415 7.12901L11.433 7.36139L11.5041 8.27808L14.3737 7.63817Z"
                            fill="#FFBB24"
                          />
                          <path
                            d="M11.6314 9.92428L11.4951 8.1665L11.4147 7.12903L8.00098 8.62753V9.80134L10.2309 8.83165L11.6314 9.92428Z"
                            fill="#FFDB56"
                          />
                          <path
                            d="M15.9964 14.8652L15.6807 13.1256L11.5039 8.27808L11.6315 9.92427L15.915 15.0874C15.9801 15.0335 16.0116 14.9487 15.9964 14.8652Z"
                            fill="#FFBB24"
                          />
                          <path
                            d="M8.01499 0.858278C6.20364 0.858278 4.72998 2.33072 4.72998 4.1406C4.72998 5.26016 5.26151 6.46217 6.30986 7.71317C7.07983 8.63201 7.83933 9.22298 7.8713 9.2477C7.91361 9.28042 7.9643 9.29677 8.01502 9.29677C8.06571 9.29677 8.11642 9.28042 8.15874 9.2477C8.19067 9.22298 8.95021 8.63201 9.72018 7.71317C10.7685 6.46217 11.3001 5.26019 11.3001 4.1406C11.3 2.33072 9.82633 0.858278 8.01499 0.858278ZM9.23155 4.14057C9.23155 4.81188 8.68686 5.35613 8.01499 5.35613C7.34311 5.35613 6.79842 4.81191 6.79842 4.14057C6.79842 3.46922 7.34311 2.925 8.01499 2.925C8.68686 2.925 9.23155 3.46925 9.23155 4.14057Z"
                            fill="#FF4A4A"
                          />
                          <path
                            d="M8.01503 0.858278C7.87147 0.858278 7.73006 0.867591 7.59131 0.885528C9.20328 1.09387 10.4526 2.47416 10.4526 4.1406C10.4526 5.26016 9.92109 6.46217 8.87275 7.71317C8.37759 8.30405 7.88712 8.75901 7.59134 9.01533C7.75553 9.15758 7.85997 9.23889 7.87134 9.2477C7.91365 9.28042 7.96434 9.29677 8.01506 9.29677C8.06575 9.29677 8.11647 9.28042 8.15878 9.2477C8.19072 9.22298 8.95025 8.63201 9.72022 7.71317C10.7686 6.46217 11.3001 5.26019 11.3001 4.1406C11.3 2.33072 9.82637 0.858278 8.01503 0.858278Z"
                            fill="#E7343F"
                          />
                          <path
                            d="M8.09619 15.1211L9.51135 14.4862L8 12.9221V15.1417C8 15.1417 8 15.1417 8.00003 15.1417C8.03269 15.1417 8.06547 15.1349 8.09619 15.1211Z"
                            fill="#FFDB56"
                          />
                          <path
                            d="M14.7394 7.93983C14.7269 7.87071 14.684 7.81083 14.6226 7.77667L14.3735 7.63814L11.5039 8.27805L15.6807 13.1256L14.7394 7.93983Z"
                            fill="#1EA4E9"
                          />
                          <path
                            d="M7.99999 15.1417C8.00002 15.1417 8.00002 15.1417 7.99999 15.1417V14.9071L4.40555 9.44833L4.09814 13.4138L7.90381 15.1211C7.93453 15.1349 7.96731 15.1417 7.99999 15.1417Z"
                            fill="#1EA4E9"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_133_311">
                            <rect width="16" height="16" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>

                      <Link
                        to={
                          "https://maps.google.com/?q=" +
                          villadata.geo_lat +
                          "," +
                          villadata.geo_long
                        }
                        className="text-fuchsia-800	ml-2"
                      >
                        Location
                      </Link>
                    </div>
                    <div className="text-[16px]">
                      Area - {villadata.size_of_property} Sq.ft
                    </div>
                    <div className="text-xl">
                      {villadata.number_of_bedrooms} BHK |{" "}
                      {villadata.number_of_bedrooms} Bedrooms |{" "}
                      {villadata.number_of_bathrooms} Bathrooms
                    </div>
                    {/* <div className="mb-2">
                  <span className="bg-indigo-500 text-white px-2 py-2  rounded-xl">
                    4.5
                  </span>{" "}
                  <a href="#!" className="text-gray-600">
                    (245 ratings &amp; 56 reviews)
                  </a>
                  </div> */}
                    <div className=" flex flex-col  ">
                      {/* <div className="flex flex-row text-[16px] space-x-2">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_116_294)">
                          <path
                            d="M11.7488 12.1H3.65588V14.9921C3.65588 15.0063 3.65527 15.0205 3.65479 15.0347H11.7499C11.7494 15.0205 11.7488 15.0063 11.7488 14.9921V12.1Z"
                            fill="#2B1448"
                          />
                          <path
                            d="M0.467896 4.75272H9.01086C9.26929 4.75272 9.47876 4.54324 9.47876 4.28482V1.12418C9.47876 0.865753 9.26929 0.656281 9.01086 0.656281H0.467896C0.209473 0.656281 0 0.865753 0 1.12418V4.28482C0 4.54324 0.209473 4.75272 0.467896 4.75272Z"
                            fill="#2B1448"
                          />
                          <path
                            d="M14.0761 7.68713V9.16528H14.3421V5.36841H15.5319C15.6753 5.36841 15.8108 5.30261 15.8996 5.18994C15.9883 5.07715 16.0204 4.92993 15.9867 4.79053L15.2712 1.83289C15.2204 1.62292 15.0325 1.47498 14.8164 1.47498H12.9319C12.716 1.47498 12.528 1.62292 12.4772 1.83289L11.7616 4.79053C11.7279 4.92993 11.76 5.07715 11.8488 5.18994C11.9375 5.30261 12.073 5.36841 12.2165 5.36841H13.4063V6.49109C13.8078 6.7384 14.0761 7.18201 14.0761 7.68713Z"
                            fill="#2B1448"
                          />
                          <path
                            d="M11.7488 11.1641V10.4557C11.7488 9.74414 12.3276 9.16528 13.0392 9.16528H13.1404V7.68713C13.1404 7.42908 12.9305 7.21924 12.6725 7.21924H2.73206C2.47412 7.21924 2.26416 7.42908 2.26416 7.68713V9.16528H2.36536C3.0769 9.16528 3.65576 9.74414 3.65576 10.4557V11.1641H11.7488Z"
                            fill="#2B1448"
                          />
                          <path
                            d="M2.71985 10.4557C2.71985 10.2603 2.56079 10.1011 2.36523 10.1011H0.694946C0.49939 10.1011 0.340332 10.2603 0.340332 10.4557V14.9921C0.340332 15.1876 0.49939 15.3467 0.694946 15.3467H2.36523C2.56079 15.3467 2.71985 15.1876 2.71985 14.9921V10.4557Z"
                            fill="#2B1448"
                          />
                          <path
                            d="M15.0642 14.9921V10.4557C15.0642 10.2603 14.905 10.1011 14.7095 10.1011H13.0392C12.8436 10.1011 12.6846 10.2603 12.6846 10.4557V14.9921C12.6846 15.1876 12.8436 15.3467 13.0392 15.3467H14.7095C14.905 15.3467 15.0642 15.1876 15.0642 14.9921Z"
                            fill="#2B1448"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_116_294">
                            <rect width="16" height="16" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      <div>Semi Deluxe Room</div>
                    </div> */}
                      <div className="flex flex-wrap lg:flex-row lg:flex-wrap text-[16px] text-black">
                        {filteredArray.map((a) => (
                          <div className="flex lg:flex-row mx-2 lg:mb-4 mb-2">
                            <div className="relative">
                              <img
                                src={a.icon}
                                alt={a.name}
                                className={`w-[25px] h-[25px] mr-2 object-contain transition-all hover:scale-[1.5] ${amenityIconFilterClass(a.name)}`}
                                onMouseOver={(e) => {
                                  e.currentTarget.nextSibling.classList.remove(
                                    "hidden"
                                  );
                                  e.currentTarget.nextSibling.classList.add(
                                    "flex"
                                  );
                                }}
                                onMouseOut={(e) => {
                                  e.currentTarget.nextSibling.classList.remove(
                                    "flex"
                                  );
                                  e.currentTarget.nextSibling.classList.add(
                                    "hidden"
                                  );
                                }}
                              />
                              <div className="hidden bg-black text-white text-sm rounded absolute bottom-full w-fit left-1/2 transform -translate-x-1/2 -translate-y-2 py-1 px-2">
                                {a.name}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="flex flex-row ">
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 23 23"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="11.5" cy="11.5" r="11.5" fill="#F6C863" />
                        <path
                          d="M9.68372 2H14.3479L12.4953 8.43002H17L10.4458 22L11.5686 13.1962H7L9.68372 2Z"
                          fill="white"
                        />
                      </svg>

                      <div className="text-black opacity-80 text-[12px] ml-2 text-center my-auto">
                        Last booked 1 hour ago
                      </div>
                    </div>
                  </div>
                  <div className="hotel-card_pricing ">
                    <div className="text-right mb-4 text-[16px] underline">
                      Prepayment Policy
                    </div>
                    <div className="flex flex-row justify-end text-center">
                      <svg
                        width="70"
                        height="31"
                        viewBox="0 0 45 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M5.27053 0H40.9996C43.2088 0 44.9996 1.79086 44.9996 4V10.9732C44.9996 13.1823 43.2088 14.9732 40.9996 14.9732H5.09995C3.19803 14.9732 1.65621 13.4314 1.65621 11.5294V10.5454C1.65621 9.94622 1.34186 9.39102 0.828106 9.08276C-0.276035 8.42028 -0.276035 6.82006 0.828106 6.15758C1.34186 5.84932 1.65621 5.29412 1.65621 4.69498V3.61432C1.65621 1.61819 3.2744 0 5.27053 0ZM4.01986 9.19582C4.89006 9.19582 5.5955 8.49038 5.5955 7.62018C5.5955 6.74998 4.89006 6.04454 4.01986 6.04454C3.14966 6.04454 2.44422 6.74998 2.44422 7.62018C2.44422 8.49038 3.14966 9.19582 4.01986 9.19582Z"
                          fill="#232322"
                        />
                      </svg>
                      <h6 className="text-[#FDFE03] text-right absolute mt-[3px] mr-1">
                        12% off
                      </h6>
                    </div>
                    <div className="flex justify-end">
                      <div className="flex flex-row my-auto">
                        <svg
                          width="51"
                          height="11"
                          viewBox="0 0 51 11"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className="absolute mt-[6px]"
                        >
                          <line
                            x1="1.80703"
                            y1="9.83866"
                            x2="49.8387"
                            y2="1.19297"
                            stroke="#FA0E0E"
                            stroke-opacity="0.8"
                            stroke-width="2"
                            stroke-linecap="round"
                          />
                        </svg>
                        <h6 className="text-black opacity-70  mr-2 ">
                          ₹{parseInt(1.12 * price_guest_pay)}
                        </h6>
                      </div>
                      <h1 className="text-black text-[24px] font-semibold">
                        ₹{price_guest_pay}
                      </h1>
                    </div>

                    <div className="text-black text-right text-[15px]">
                      +₹{calcTaxAmount(price_guest_pay)} TAX ({TAX_PERCENT}%)
                    </div>
                    <div className="text-black font-bold text-right text-[17px]">
                      / per night
                    </div>

                    {/* <button className="bg-indigo-500 hover:bg-indigo-600 text-white font-medium py-2 px-4 rounded">Check Rooms</button> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div></>
  );
};

export default HotelCard;
